import { Form, Success } from './components';

const PaymentSettingsFlow = {
  Form,
  Success,
};

export { PaymentSettingsFlow };
